// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--BBy_I","buttonPlayMouseExit":"styles-module--button-play-mouse-exit--2Y8qC","icon":"styles-module--icon--3WPf-"};